import { useEffect, useState } from "react";
import TitleBox from "../../components/Common/TitleBox";
import { Notice } from "../../system/types/interface";
import { NoticeApi, ErrorHandler } from "../../system/ApiService";
import NoticeDetailBoard from "../../components/Notice/NoticeDetailBoard";
import { useHistory, useParams } from "react-router-dom";
import AlertModal from "../../components/Common/AlertModal";

interface NoticeProps {
  location: any;
}
// URL 파라미터에서 ID를 받기 위한 인터페이스
interface NoticeDetailParams {
  noticeId: string;
}

function NoticeDetail({ location }: NoticeProps) {
  const [id, setId] = useState(0);
  const [data, setData]: any = useState<Notice[]>([]);
  let history = useHistory();
   // URL 파라미터를 사용하기 위한 useParams 훅 추가
   const params = useParams<NoticeDetailParams>();

   useEffect(() => {
    // location.state로부터 또는 URL 파라미터로부터 noticeId 가져오기
    let noticeId: number;
    
    if (location.state && location.state.displays) {
      noticeId = Number(location.state.displays);
    } else if (params.noticeId) {
      noticeId = Number(params.noticeId);
    } else {
      // ID가 없는 경우 이전 페이지로 이동
      history.goBack();
      return;
    }
    
    setId(noticeId);
    
    // 공지사항 데이터 가져오기
    NoticeApi.GetNotice(noticeId)
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        let msg = ErrorHandler(error);
        AlertModal("msg", msg);
      });
  }, []);

  // 데이터 받을 때마다 조회수 증가
  useEffect(() => {
    const newData: Notice = {
      noticeTitle: data.noticeTitle,
      noticeContent: data.noticeContent,
      noticeModifiedAt: data.noticeModifiedAt,
      noticeWriter: data.noticeWriter,
      noticeId: data.noticeId,
      noticeMain: data.noticeMain,
      noticeCreatedAt: data.noticeCreatedAt,
      noticeViews: data.noticeViews + 1,
      noticeSendMail: data.noticeSendMail,
      teamName: data.teamName,
      type: data.type,
      fileuploadFolder: data.fileuploadFolder,
      employeeId: data.employeeId,
    };
    if (data.noticeTitle) {
      NoticeApi.UpdateNotice(newData)
        .then(() => {})
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  }, [data]);

  return (
    <div>
      <TitleBox title="전사 공지" />
      <NoticeDetailBoard data={data} />
    </div>
  );
}

export default NoticeDetail;
